import React, { FC } from 'react';

import LegalPage from '~/projects/polyllm-chat/components/LegalPage';
import LegalLoading from '~/projects/polyllm-chat/components/LegalPage/components/LegalLoading';
import { privacyPolicyMarkdown } from '~/projects/polyllm-chat/components/LegalPage/config/content';
import { privacyPolicyMarkdownUs } from '~/projects/polyllm-chat/components/LegalPage/config/contentUs';
import { legalMarkdownVariables } from '~/projects/polyllm-chat/components/LegalPage/config/variables';
import useLegalMarkdownByCountry from '~/projects/polyllm-chat/components/LegalPage/hooks/useLegalMarkdownByCountry';

const PrivacyPolicyPage: FC = () => {
  const { markdown, ready } = useLegalMarkdownByCountry({
    default: privacyPolicyMarkdown,
    US: privacyPolicyMarkdownUs,
  });

  if (!ready) {
    return <LegalLoading />;
  }

  return <LegalPage markdown={markdown} variables={legalMarkdownVariables} />;
};

export default PrivacyPolicyPage;
